module.exports = __webpack_public_path__ + "static/media/checklist_selected.6dcc661b.svg";